import { render, staticRenderFns } from "./UserTagsForm.vue?vue&type=template&id=ac65f78e"
import script from "./UserTagsForm.vue?vue&type=script&lang=ts"
export * from "./UserTagsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports